import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import { extractAccountGroupingProps } from '@hotjar/webapp/tracking/utils';

import type { OwnedAccount, SiteAccount, Account } from '@hotjar/account';

/**
 * This event is emitted when using the 3D Secure 2.0 flow and the authentication modal closes,
 *  either because the authentication was completed or because the customer canceled the process.
 */
export function authenticationModalClosed(account: Account | SiteAccount | OwnedAccount): void {
  Segment.track('3DS Authentication Modal Closed', {
    ...extractAccountGroupingProps(account),
  });
}

/**
 * This event is emitted when using the 3D Secure 2.0 flow and the authentication modal is rendered.
 */
export function authenticationModalRendered(account: Account | SiteAccount | OwnedAccount): void {
  Segment.track('3DS Authentication Modal Rendered', {
    ...extractAccountGroupingProps(account),
  });
}

/**
 * This event is emitted when using the 3D Secure 2.0 flow and the customer cancels the 3D Secure challenge.
 */
export function authenticationModalCustomerCancelled(
  account: Account | SiteAccount | OwnedAccount,
): void {
  Segment.track('3DS Authentication Modal Customer Cancelled', {
    ...extractAccountGroupingProps(account),
  });
}
